<template>
  <section class="tab-box">
    <h3 class="title">2024年二级建造师<b>报考条件</b>「自助查询」</h3>
    <div class="line"></div>
    <div class="content">
      <p>1.请选择您的最高学历</p>
      <ul>
        <li :class="{ on: educationIndex == index }" v-for="(item, index) in educations" :key="index" @click="educationIndex = index">
          {{ item }}
        </li>
      </ul>
      <p>2.请选择您所学专业</p>
      <ul>
        <li :class="{ on: majorIndex == index }" v-for="(item, index) in majors" :key="index" @click="majorIndex = index">{{ item }}</li>
      </ul>
      <p>3.请选择您的工作年限</p>
      <ul>
        <li :class="{ on: workYearIndex == index }" v-for="(item, index) in workYears" :key="index" @click="workYearIndex = index">{{ item }}</li>
      </ul>
      <div class="submit-box">
        <input type="text" placeholder="请输入您的手机号" v-model="mobile" />
        <button @click="onSubmit">查询结果</button>
      </div>
    </div>
    <submit-success-dialog ref="successRef"></submit-success-dialog>
  </section>
</template>
<script>
import { Message } from 'element-ui'
import SubmitSuccessDialog from './submit-success-dialog'
import md5 from 'js-md5'
import { phoneValidator } from '@/utils'
import { graduatePromot } from '@/api/index'
export default {
  data() {
    return {
      educationIndex: 0,
      educations: ['中专', '大专', '本科', '研究生'],
      majorIndex: 0,
      majors: ['工程类', '工程经济类', '其他'],
      workYearIndex: 0,
      workYears: ['0-2年', '3-4年', '5-6年', '6年以上'],
      mobile: ''
    }
  },
  components: {
    SubmitSuccessDialog
  },
  methods: {
    onSubmit() {
      if (!this.mobile.length) {
        return Message.error('请输入手机号')
      }
      if (!phoneValidator(this.mobile)) {
        return Message.error('手机号格式错误')
      }

      const gt = new Date().getTime().toString()
      graduatePromot({
        time: gt,
        encryPwd: md5(gt + 'verify'),
        mobile: this.mobile,
        originurl: window.location.origin + window.location.pathname,
        collegeName: '二级建造师',
        orign: '百度信息流',
        promotedAccount: '梓学教育吉re07-sl',
        remark: `报考条件：【学历：${this.educations[this.educationIndex]}】【专业：${this.majors[this.majorIndex]}】【工作年限：${
          this.workYears[this.workYearIndex]
        }】`
      }).then(res => {
        window._agl && window._agl.push(['track', ['success', { t: 3 }]])
        this.$refs.successRef.open('平台升级，稍等为您转接人工客服，请注意接收查询结果')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.tab-box {
  .title {
    text-align: center;
    font-size: 36px;
    font-weight: bold;
    margin: 25px 0 15px;
    color: rgb(17, 67, 135);
    b {
      color: #d51719;
    }
  }
  .line {
    width: 740px;
    margin: 0 auto 30px;
    border-bottom: 1px solid rgb(231, 231, 231);
  }
  .content {
    width: 750px;
    margin: 0 auto;
    p {
      color: #333;
      font-size: 18px;
      margin-bottom: 15px;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 150px;
        display: block;
        line-height: 56px;
        height: 56px;
        border-radius: 3px;
        background-color: #efefef;
        font-size: 18px;
        color: #333333;
        text-align: center;
        margin-bottom: 15px;
        cursor: pointer;
        &:not(:last-child) {
          margin-right: 23px;
        }
        &.on {
          color: #fff;
          background: rgb(17, 71, 143);
        }
      }
    }
    .submit-box {
      display: flex;
      align-items: center;
      margin-top: 30px;
      input {
        flex: 1;
        height: 50px;
        text-align: center;
        margin-right: 20px;
      }
      button {
        flex: 1;
        height: 50px;
        border: none;
        outline: none;
        color: #fff;
        cursor: pointer;
        background: rgb(17, 71, 143);
      }
    }
  }
}
</style>
